import { apiClient } from './client';

export interface AdminStats {
  total: number;
  submitted: number;
  completionRate: number;
  gradeDistribution: Record<string, number>;
  dailyTrend: { day: string; count: number }[];
  userCount: number;
}

export interface AdminDiagnosis {
  id: string;
  companyName: string | null;
  industry: string | null;
  scale: string | null;
  revenue: string | null;
  status: string;
  totalScore: number | null;
  grade: string | null;
  createdAt: string;
  submittedAt: string | null;
}

export interface Lead {
  id: string;
  name: string;
  phone: string;
  companyName: string | null;
  message: string | null;
  status: string;
  createdAt: string;
}

export async function getAdminStats(): Promise<AdminStats> {
  const res = await apiClient.get<AdminStats>('/admin/stats');
  return res.data;
}

export async function getAdminDiagnoses(params: {
  industry?: string;
  scale?: string;
  grade?: string;
  status?: string;
  keyword?: string;
}): Promise<AdminDiagnosis[]> {
  const res = await apiClient.get<AdminDiagnosis[]>('/admin/diagnoses', { params });
  return res.data;
}

export async function getLeads(): Promise<Lead[]> {
  const res = await apiClient.get<Lead[]>('/leads');
  return res.data;
}
